import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common';

const states: Ng1StateDeclaration[] = [
    {
        name: 'tag',
        url: '/tag/:tagDefinitionGuid/:beginDate/:endDate',
        component: 'wtTagState',
        abstract: true,
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([
                Roles.master,
                Roles.engineer,
                Roles.operator,
                Roles.reader
            ]),
            dates: Resolve.datesResolve
        },
        data: {
            isAuthenticated: true,
            isConnected: true,
            breadcrumbs: {
                level3StateName: 'Tags',
                level4: ''
            },
        },
        params: {
            tag: null,
            beginDate: '',
            endDate: '',
            hideHeaders: true
        }
    },
    {
        name: 'tag.general',
        url: '/general',
        component: 'wtTagGeneralState',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([
                Roles.master, Roles.engineer, Roles.operator, Roles.reader
            ])
        },
        data: {
            displayName: 'Tag',
            icon: 'fa-tag',
            isAuthenticated: true,
            isConnected: true,
            editRoles: [Roles.master, Roles.engineer],
            editButtonVisibility: () => true,
            breadcrumbs: {
                level3StateName: 'Tags',
                level4: ''
            },
            subMenu: {
                'type': 'tags',
                subState: 'tag.general',
                parentName: 'tags'
            }
        },
        params: {
            tag: null,
            beginDate: '',
            endDate: ''
        }
    },
    {
        name: 'tag.statistics',
        url: '/statistics/:beginDate/:endDate',
        component: 'wtTagsStatisticsState',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([
                Roles.master, Roles.engineer, Roles.operator, Roles.reader
            ]),
            dates: Resolve.datesResolve
        },
        data: {
            sortingOrder: -1,
            icon: 'fa-bar-chart',
            displayName: 'Tags statistics',
            editRoles: [Roles.master, Roles.engineer],
            editButtonVisibility: () => true,
            breadcrumbs: {
                level3StateName: 'Tag',
                level4: '',
                level5: 'Tags statistics'
            }
        },
        params: {
            tag: null,
            beginDate: '',
            endDate: '',
            hideHeaders: true
        }
    },
    {
        name: 'tag.shewhart',
        url: '/shewhart',
        component: 'wtShewhartState',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([
                Roles.master, Roles.engineer, Roles.operator, Roles.reader
            ])
        },
        data: {
            displayName: 'Shewhart',
            icon: 'fa-stethoscope',
            isAuthenticated: true,
            isConnected: true,
            editRoles: [Roles.master, Roles.engineer],
            editButtonVisibility: () => false,
            breadcrumbs: {
                level3StateName: 'Tag',
                level4: '',
                level5: 'Shewhart'
            }
        },
        params: {
            tag: null,
            beginDate: '',
            endDate: ''
        }
    }
];

export default states;